<template lang="pug">
extends ../Base/Card.pug

block card-header
    div.card-header-title
        div.multimedia-title.event-title
            div.event-class-title-icon(
                v-if="eventClass"
                v-bind:style="getEventClassStyle(eventClass)"
                v-bind:title="$t(`events.eventClass.${eventClass}`)")
                component(
                    v-bind:is="getEventClassIcon(eventClass)"
                    title='')

            h2.title(v-if="title") {{ title }}

    div.event-organizer(
        v-if="organizerName")
        h2.organizer-name {{ organizerName }}

    h2.event-period(v-if="period") {{ period }}


block card-contents
    slot


block card-social
    div.social-actions(v-if="social && item")
        social-follow(
            v-if="social && item"
            resource="events"
            v-bind:item="item"
            class-name="thin")


</template>

<script>
import BaseCard from '@/components/Base/Card';
import EventsMixin from '@/components/Base/EventsMixin';

export default {
    name: 'event-card',

    extends: BaseCard,

    props: {
        className: {        type: String, default: 'event-card' },
        useCoverImage: {    type: Boolean, default: false },
        usePalette: {       type: Boolean, default: true },
        resolution: {       type: Object, default: () => { return {x: '50vw', y: '80%'}; }}
    },

    mixins: [ EventsMixin ],

    computed: {
        ingressText: function () {
            return this.getIngressText(this.item);
        },

        /**
         * Events have no cover image.
         */
        coverImageSrc: function () {
            return null;
        },

        organizerName: function () {
            return this.item && this.item.OrganizerInfo &&
                this.item.OrganizerInfo.OrganizationName;
        },

        eventClass: function () {
            return this.item && this.item.EventClass;
        },

        period: function () {
            return this.getEventPeriodString(this.item);
        }
    },

    data: function () {
        return {
            resource: 'events'
        };
    },

    methods: {
        getCardRoute: function (item) {
            return this.getRoute(
                item, null, 'Event');
        }
    }
};
</script>

<style lang="scss">
// @import '~assets/styles/mixins';

.event-card {
    margin-right: 1rem;
    .card-header {
        width: 100%;
        .card-header-title {
            font-family: 'Sabon LT W01 Bold', serif;
            font-weight: normal;
            h2.title {
                max-width: calc(100% - 55px); // leave space for .event-class-title-icon
                margin-bottom: 0;
                font-family: inherit;
                line-height: 1.25;
                letter-spacing: -0.5px;
                @include dowrap;
            }
        }
        .details {
            font-family: $helvetica-light;
        }
    }
    .card-link {
        color: $dark-gray-3;
    }
    .event-organizer {
        display: inline-flex;
        align-items: baseline;
        margin-left: 3px;
        font-family: $helvetica-roman;
        span.label {
            margin-right: 0.5em;
            font-family: inherit;
            font-weight: normal;
            font-size: 0.875rem;
        }
        .organizer-name {
            font-family: inherit;
            font-size: 1rem;
            line-height: 1;
        }
    }
    .event-period {
        padding: 0.25rem 0.125rem;
        font-family: $helvetica-roman;
        font-family: $helvetica-light;
        text-decoration: none;
        &, &:hover {
            color: $dark-gray-2;
        }
    }
    .body-html {
        font-family: $helvetica-light;
        font-weight: normal;
        letter-spacing: 1px;
    }
}
</style>
